<template>
  <div>
    <svg
      class="clickable"
      version="1.1"
      id="Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
      x="0px"
      y="0px"
      width="274.934px"
      height="600px"
      style="max-height:200px"
      viewBox="263.733 0 274.934 600"
      enable-background="new 263.733 0 274.934 600"
      xml:space="preserve"
    >
      <path
        id="bonnet"
        :style="bonnetClass"
        v-on:click="changeSeverity('bonnet')"
        d="M446.667,17.108c-25.501,1.49-51.876-2.507-75.2-0.574c-26.921,2.23-52.904,16.764-71.967,19.2
	c-44.421,28.095-37.11,10.376-37.524,15.342v495.088c1.048,12.571,26.757,20.493,50.824,23.436c14.9,7.226,34.254,14.732,58.4,16.8
	c25.216,2.159,47.403-7.906,75.467-6.267V17.108z"
      />
      <linearGradient
        id="SVGIDD_1_"
        gradientUnits="userSpaceOnUse"
        x1="712.5645"
        y1="-65.4236"
        x2="712.5645"
        y2="-30.1233"
        gradientTransform="matrix(1.197253e-010 -2.6667 -2.6667 -1.197253e-010 364.3145 2201.6411)"
      >
        <stop offset="0" style="stop-color:#808080" />
        <stop offset="0.2533" style="stop-color:#B7B7B7" />
        <stop offset="0.5121" style="stop-color:#EBEBEB" />
        <stop offset="0.6393" style="stop-color:#FFFFFF" />
      </linearGradient>
      <path
        id="bumper"
        :style="bumperClass"
        v-on:click="changeSeverity('bumper')"
        d="M444.533,582.133c28-3.2,55.467-7.733,73.601-12.267c12.267-2.934,19.999-9.066,20.533-21.6V54.666
	c-0.534-12.533-8.267-18.666-20.533-21.6C500,28.533,472.533,24,444.533,20.8V582.133z"
      />
      <g id="H-Light_1_">
        <linearGradient
          id="SVGIDD_2_"
          gradientUnits="userSpaceOnUse"
          x1="249.7485"
          y1="1399.0032"
          x2="247.08"
          y2="1407.7841"
          gradientTransform="matrix(1.197253e-010 -2.6667 2.6667 1.197253e-010 -3392.3809 1193.6409)"
        >
          <stop offset="0" style="stop-color:#FFFFFF" />
          <stop offset="1" style="stop-color:#676767" />
        </linearGradient>
        <path
          fill="url(#SVGIDD_2_)"
          d="M358,493.465c-5.6,7.467-10.667,15.733-14.4,24.533l-15.2,34.4c-2.4,5.333,0,11.199,4.8,13.866
		l31.733-46.667L358,493.465z"
        />

        <linearGradient
          id="SVGIDD_3_"
          gradientUnits="userSpaceOnUse"
          x1="234.3955"
          y1="1405.092"
          x2="252.7026"
          y2="1405.092"
          gradientTransform="matrix(1.197253e-010 -2.6667 2.6667 1.197253e-010 -3392.3809 1193.6409)"
        >
          <stop offset="0" style="stop-color:#FFFFFF" />
          <stop offset="1" style="stop-color:#676767" />
        </linearGradient>
        <path
          fill="url(#SVGIDD_3_)"
          d="M333.2,566.265c1.333,0.8,2.933,1.333,4.533,1.333l18.4,1.067c7.467,0.267,14.4-2.134,19.733-6.4
		l-11.2-42.399L333.2,566.265z"
        />

        <linearGradient
          id="SVGIDD_4_"
          gradientUnits="userSpaceOnUse"
          x1="256.6299"
          y1="1409.3225"
          x2="254.5122"
          y2="1419.1139"
          gradientTransform="matrix(1.197253e-010 -2.6667 2.6667 1.197253e-010 -3392.3809 1193.6409)"
        >
          <stop offset="0" style="stop-color:#676767" />
          <stop offset="1" style="stop-color:#FFFFFF" />
        </linearGradient>
        <path
          fill="url(#SVGIDD_4_)"
          d="M376.133,561.998c5.067-4.267,9.067-10.133,10.4-17.066l14.4-73.066
		c0.533-2.134,0.533-4,0.533-5.334l-36.266,53.066L376.133,561.998z"
        />

        <linearGradient
          id="SVGIDD_5_"
          gradientUnits="userSpaceOnUse"
          x1="254.2998"
          y1="1418.5442"
          x2="275.3897"
          y2="1411.7715"
          gradientTransform="matrix(1.197253e-010 -2.6667 2.6667 1.197253e-010 -3392.3809 1193.6409)"
        >
          <stop offset="0" style="stop-color:#676767" />
          <stop offset="1" style="stop-color:#FFFFFF" />
        </linearGradient>
        <path
          fill="url(#SVGIDD_5_)"
          d="M379.6,471.331c-8,6.4-15.467,13.867-21.6,22.134l6.933,26.4l36.268-53.334
		c-0.533-6.934-5.601-8-13.068-2.133L379.6,471.331z"
        />
        <g>
          <radialGradient
            id="SVGIDD_6_"
            cx="59.1768"
            cy="413.2385"
            r="4.5"
            gradientTransform="matrix(2.6667 0 0 -2.6667 218.3261 1604.2346)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0" style="stop-color:#F7F7F7" />
            <stop offset="0.4321" style="stop-color:#F5F5F5" />
            <stop offset="0.6076" style="stop-color:#EEEEEE" />
            <stop offset="0.7366" style="stop-color:#E2E2E2" />
            <stop offset="0.8428" style="stop-color:#D1D0D1" />
            <stop offset="0.9338" style="stop-color:#BBBABB" />
            <stop offset="1" style="stop-color:#A5A4A5" />
          </radialGradient>
          <circle
            fill="url(#SVGIDD_6_)"
            v-on:click="changeSeverity('bonnet')"
            cx="376.133"
            cy="502.265"
            r="12"
          />
        </g>
        <g>
          <radialGradient
            id="SVGIDD_7_"
            cx="245.8013"
            cy="1407.7922"
            r="7.2563"
            gradientTransform="matrix(1.197253e-010 -2.6667 2.6667 1.197253e-010 -3392.3809 1193.6409)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0" style="stop-color:#F7F7F7" />
            <stop offset="0.4321" style="stop-color:#F5F5F5" />
            <stop offset="0.6076" style="stop-color:#EEEEEE" />
            <stop offset="0.7366" style="stop-color:#E2E2E2" />
            <stop offset="0.8428" style="stop-color:#D1D0D1" />
            <stop offset="0.9338" style="stop-color:#BBBABB" />
            <stop offset="1" style="stop-color:#A5A4A5" />
          </radialGradient>
          <circle
            fill="url(#SVGIDD_7_)"
            v-on:click="changeSeverity('bonnet')"
            cx="361.733"
            cy="538.265"
            r="19.467"
          />

          <radialGradient
            id="SVGIDD_8_"
            cx="347.3867"
            cy="1330.5276"
            r="1.3364"
            gradientTransform="matrix(0.3528 -2.6432 2.6432 0.3528 -3277.6753 986.975)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0" style="stop-color:#FFFFFF" />
            <stop offset="0.3265" style="stop-color:#FDFDFD" />
            <stop offset="0.5013" style="stop-color:#F5F5F5" />
            <stop offset="0.6402" style="stop-color:#E7E7E7" />
            <stop offset="0.7601" style="stop-color:#D4D4D4" />
            <stop offset="0.8679" style="stop-color:#BBBBBB" />
            <stop offset="0.9654" style="stop-color:#9D9D9D" />
            <stop offset="1" style="stop-color:#909090" />
          </radialGradient>
          <circle fill="url(#SVGIDD_8_)" cx="361.733" cy="538.265" r="3.467" />
        </g>
        <path
          fill="#B1B1B1"
          v-on:click="changeSeverity('bonnet')"
          d="M332.4,556.932c0-0.8,0.267-1.601,0.533-2.4l15.2-34.399c7.733-17.334,19.733-33.067,34.667-44.801
		l8.533-6.933c2.666-2.134,4-2.667,4.8-2.667c0,0.267,0.267,1.066,0.267,1.866c0,1.067-0.267,2.134-0.267,3.467l-14.399,73.067
		c-2.4,11.732-13.066,20.267-25.067,19.466l-18.4-1.066C334.534,562.531,332.4,559.598,332.4,556.932L332.4,556.932z
		 M327.333,556.932c0,5.6,4.267,10.399,10.4,10.666l18.4,1.067c14.4,0.8,27.2-9.334,30.134-23.467l14.401-73.066
		c0.266-1.601,0.533-3.2,0.533-4.534c0-7.732-5.334-9.066-13.068-2.933l-8.533,6.933c-15.733,12.268-28,28.534-36,46.667l-15.2,34.4
		C327.867,553.998,327.333,555.331,327.333,556.932L327.333,556.932z"
        />
      </g>
      <g id="H-Light_2_">
        <linearGradient
          id="SVGIDD_9_"
          gradientUnits="userSpaceOnUse"
          x1="-2025.0498"
          y1="1399.6272"
          x2="-2027.7186"
          y2="1408.4086"
          gradientTransform="matrix(-1.197253e-010 2.6667 2.6667 1.197253e-010 -3392.3809 5475.6855)"
        >
          <stop offset="0" style="stop-color:#FFFFFF" />
          <stop offset="1" style="stop-color:#676767" />
        </linearGradient>
        <path
          fill="url(#SVGIDD_9_)"
          d="M359.667,109.866c-5.6-7.467-10.667-15.733-14.4-24.533l-15.2-34.667
		c-2.4-5.333,0-11.199,4.8-13.866L366.6,83.467L359.667,109.866z"
        />

        <linearGradient
          id="SVGIDD_10_"
          gradientUnits="userSpaceOnUse"
          x1="-2040.3901"
          y1="1405.717"
          x2="-2022.0825"
          y2="1405.717"
          gradientTransform="matrix(-1.197253e-010 2.6667 2.6667 1.197253e-010 -3392.3809 5475.6855)"
        >
          <stop offset="0" style="stop-color:#FFFFFF" />
          <stop offset="1" style="stop-color:#676767" />
        </linearGradient>
        <path
          fill="url(#SVGIDD_10_)"
          v-on:click="changeSeverity('bonnet')"
          d="M334.867,37.067c1.333-0.8,2.933-1.333,4.533-1.333l18.4-1.067c7.467-0.267,14.4,2.134,19.733,6.4
		l-11.2,42.4L334.867,37.067z"
        />

        <linearGradient
          id="SVGIDD_11_"
          gradientUnits="userSpaceOnUse"
          x1="-2018.2163"
          y1="1409.9368"
          x2="-2020.3339"
          y2="1419.7283"
          gradientTransform="matrix(-1.197253e-010 2.6667 2.6667 1.197253e-010 -3392.3809 5475.6855)"
        >
          <stop offset="0" style="stop-color:#676767" />
          <stop offset="1" style="stop-color:#FFFFFF" />
        </linearGradient>
        <path
          fill="url(#SVGIDD_11_)"
          v-on:click="changeSeverity('bonnet')"
          d="M377.8,41.067c5.067,4.267,9.067,10.134,10.4,17.066L402.6,131.2c0.533,2.133,0.533,4,0.533,5.333
		L366.6,83.467L377.8,41.067z"
        />

        <linearGradient
          id="SVGIDD_12_"
          gradientUnits="userSpaceOnUse"
          x1="-2020.4932"
          y1="1419.1672"
          x2="-1999.4036"
          y2="1412.3947"
          gradientTransform="matrix(-1.197253e-010 2.6667 2.6667 1.197253e-010 -3392.3809 5475.6855)"
        >
          <stop offset="0" style="stop-color:#676767" />
          <stop offset="1" style="stop-color:#FFFFFF" />
        </linearGradient>
        <path
          fill="url(#SVGIDD_12_)"
          v-on:click="changeSeverity('bonnet')"
          d="M381.267,132c-8-6.4-15.467-13.867-21.6-22.134l6.933-26.399l36.268,53.066
		c-0.533,6.934-5.601,8-13.067,2.133L381.267,132z"
        />
        <g>
          <radialGradient
            id="SVGIDD_13_"
            cx="59.8018"
            cy="563.6877"
            r="4.5"
            gradientTransform="matrix(2.6667 0 0 -2.6667 218.3261 1604.2346)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0" style="stop-color:#F7F7F7" />
            <stop offset="0.4321" style="stop-color:#F5F5F5" />
            <stop offset="0.6076" style="stop-color:#EEEEEE" />
            <stop offset="0.7366" style="stop-color:#E2E2E2" />
            <stop offset="0.8428" style="stop-color:#D1D0D1" />
            <stop offset="0.9338" style="stop-color:#BBBABB" />
            <stop offset="1" style="stop-color:#A5A4A5" />
          </radialGradient>
          <circle
            fill="url(#SVGIDD_13_)"
            v-on:click="changeSeverity('bonnet')"
            cx="377.8"
            cy="101.067"
            r="12"
          />
        </g>
        <g>
          <radialGradient
            id="SVGIDD_14_"
            cx="-2028.9824"
            cy="1408.4172"
            r="7.2521"
            gradientTransform="matrix(-1.197253e-010 2.6667 2.6667 1.197253e-010 -3392.3809 5475.6855)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0" style="stop-color:#F7F7F7" />
            <stop offset="0.4321" style="stop-color:#F5F5F5" />
            <stop offset="0.6076" style="stop-color:#EEEEEE" />
            <stop offset="0.7366" style="stop-color:#E2E2E2" />
            <stop offset="0.8428" style="stop-color:#D1D0D1" />
            <stop offset="0.9338" style="stop-color:#BBBABB" />
            <stop offset="1" style="stop-color:#A5A4A5" />
          </radialGradient>
          <circle
            fill="url(#SVGIDD_14_)"
            v-on:click="changeSeverity('bonnet')"
            cx="363.4"
            cy="65.067"
            r="19.467"
          />

          <radialGradient
            id="SVGIDD_15_"
            cx="-1907.3481"
            cy="1632.1077"
            r="1.3356"
            gradientTransform="matrix(0.3528 2.6432 2.6432 -0.3528 -3277.6753 5682.3535)"
            gradientUnits="userSpaceOnUse"
          >
            <stop offset="0" style="stop-color:#FFFFFF" />
            <stop offset="0.3265" style="stop-color:#FDFDFD" />
            <stop offset="0.5013" style="stop-color:#F5F5F5" />
            <stop offset="0.6402" style="stop-color:#E7E7E7" />
            <stop offset="0.7601" style="stop-color:#D4D4D4" />
            <stop offset="0.8679" style="stop-color:#BBBBBB" />
            <stop offset="0.9654" style="stop-color:#9D9D9D" />
            <stop offset="1" style="stop-color:#909090" />
          </radialGradient>
          <circle fill="url(#SVGIDD_15_)" cx="363.4" cy="65.067" r="3.467" />
        </g>
        <path
          fill="#B1B1B1"
          v-on:click="changeSeverity('bonnet')"
          d="M334.067,46.4c0-2.666,2.133-5.6,5.6-5.866l18.4-1.066c12-0.534,22.667,7.733,25.066,19.466l14.4,73.067
		c0.267,1.333,0.267,2.666,0.267,3.467c0,0.8,0,1.6-0.267,1.866c-0.8,0-2.133-0.533-4.8-2.667L384.2,128
		c-14.934-11.733-26.934-27.467-34.667-44.8l-15.2-34.4C334.333,48,334.067,47.2,334.067,46.4L334.067,46.4z M329,46.4
		c0,1.334,0.267,2.934,0.8,4.267l15.467,34.667c8,18.134,20.267,34.4,36,46.667l8.533,6.933c7.733,6.134,13.067,4.534,13.067-2.933
		c0-1.334-0.268-2.934-0.533-4.533l-14.4-73.067C385.267,44.267,372.2,34.133,357.8,34.933L339.4,36C333.533,36,329,40.8,329,46.4
		L329,46.4z"
        />
      </g>
      <g>
        <linearGradient
          id="SVGIDD_16_"
          gradientUnits="userSpaceOnUse"
          x1="611.4658"
          y1="-2.4138"
          x2="655.8096"
          y2="-2.4138"
          gradientTransform="matrix(1.197253e-010 -2.6667 -2.6667 -1.197253e-010 364.3145 2201.6411)"
        >
          <stop offset="0" style="stop-color:#FFFFFF" />
          <stop offset="1" style="stop-color:#999999" />
        </linearGradient>
        <path
          fill="url(#SVGIDD_16_)"
          d="M408,465.333l-15.2,80c-2.933,15.733-16.533,26.667-32,25.866l-19.733-1.066
		c-3.2-0.267-6.133-1.866-8-4c1.6,1.066,3.467,1.6,5.333,1.867l18.4,1.066c14.4,0.8,27.2-9.334,30.133-23.467l14.401-73.066
		c2.133-11.467-3.467-14.934-12.534-7.467L380,472c-6.4,5.066-12.267,10.666-17.333,16.8c6.4-8.8,14.133-16.8,22.667-23.733
		l9.066-7.467C404.267,449.067,410.133,452.8,408,465.333z"
        />
      </g>
      <g>
        <linearGradient
          id="SVGIDD_17_"
          gradientUnits="userSpaceOnUse"
          x1="-1626.2788"
          y1="-2.4138"
          x2="-1581.9346"
          y2="-2.4138"
          gradientTransform="matrix(-1.197253e-010 2.6667 -2.6667 -1.197253e-010 364.3145 4369.1426)"
        >
          <stop offset="0" style="stop-color:#FFFFFF" />
          <stop offset="1" style="stop-color:#999999" />
        </linearGradient>
        <path
          fill="url(#SVGIDD_17_)"
          d="M408,138.133l-15.2-80c-2.933-15.733-16.533-26.666-32-25.866l-19.733,1.066
		c-3.2,0.267-6.133,1.867-8,4c1.6-1.066,3.467-1.6,5.333-1.866l18.4-1.067c14.4-0.8,27.2,9.334,30.133,23.467l14.401,73.066
		c2.133,11.467-3.467,14.934-12.534,7.467l-8.8-6.933c-6.4-5.067-12.267-10.667-17.333-16.801
		c6.4,8.801,14.133,16.801,22.667,23.733l9.066,7.467C404.267,154.4,410.133,150.666,408,138.133z"
        />
      </g>
      <g>
        <path
          fill="#CCCCCC"
          d="M521.066,502.4c-4.8,38.667-4.533,35.467-9.866,44l3.733-30.133c0.8-6.667-6.4-11.467-11.733-7.733
		L485.066,520.8c-15.199,10.133-25.333,26.666-28,45.333c-2.666-3.2-1.066-8.8,0.267-16.8c2.934-19.733,14.134-31.2,30.934-42.134
		l20-13.066C514.134,490.133,522.134,495.199,521.066,502.4z"
        />
      </g>
      <g id="Sign_2_">
        <linearGradient
          id="SVGIDD_18_"
          gradientUnits="userSpaceOnUse"
          x1="711.7646"
          y1="-40.1819"
          x2="711.7646"
          y2="-25.4817"
          gradientTransform="matrix(1.197253e-010 -2.6667 -2.6667 -1.197253e-010 364.3145 2201.6411)"
        >
          <stop offset="0" style="stop-color:#E6E6E6" />
          <stop offset="1" style="stop-color:#F2F2F2" />
        </linearGradient>
        <path
          fill="url(#SVGIDD_18_)"
          d="M471.467,215.734v175.732c0,2.4-1.867,4.267-4.267,4.267h-30.667c-2.399,0-4.267-1.866-4.267-4.267
		V215.734c0-2.4,1.867-4.267,4.267-4.267h30.4C469.6,211.467,471.467,213.333,471.467,215.734z"
        />

        <linearGradient
          id="SVGIDD_19_"
          gradientUnits="userSpaceOnUse"
          x1="711.7646"
          y1="-40.4163"
          x2="711.7646"
          y2="-25.2739"
          gradientTransform="matrix(1.197253e-010 -2.6667 -2.6667 -1.197253e-010 364.3145 2201.6411)"
        >
          <stop offset="0" style="stop-color:#666666" />
          <stop offset="1" style="stop-color:#E6E6E6" />
        </linearGradient>
        <path
          fill="url(#SVGIDD_19_)"
          d="M472,215.2V392c0,2.399-2.134,4.533-4.8,4.533h-30.934c-2.667,0-4.8-1.867-4.8-4.533V215.2
		c0-2.4,2.133-4.534,4.8-4.534H467.2C469.866,210.666,472,212.8,472,215.2z M432.8,392c0,1.866,1.601,3.199,3.467,3.199H467.2
		c1.866,0,3.467-1.6,3.467-3.199V215.2c0-1.867-1.601-3.2-3.467-3.2h-30.934c-1.866,0-3.467,1.6-3.467,3.2V392L432.8,392z"
        />
      </g>
      <g>
        <path
          fill="#CCCCCC"
          d="M521.066,101.067c-4.8-38.667-4.533-35.467-9.866-44l3.733,30.134c0.8,6.666-6.4,11.466-11.733,7.732
		l-18.134-12.267c-15.199-10.133-25.333-26.666-28-45.333c-2.666,3.2-1.066,8.8,0.267,16.8c2.4,19.733,13.867,31.2,30.667,42.134
		l20,13.066C514.134,113.067,522.134,108.267,521.066,101.067z"
        />
      </g>
      <linearGradient
        id="SVGIDD_20_"
        gradientUnits="userSpaceOnUse"
        x1="642.7148"
        y1="19.3176"
        x2="660.1957"
        y2="19.3176"
        gradientTransform="matrix(1.197253e-010 -2.6667 -2.6667 -1.197253e-010 364.3145 2201.6411)"
      >
        <stop offset="0" style="stop-color:#D8D8D8" />
        <stop offset="0.8" style="stop-color:#FFFFFF" />
      </linearGradient>
      <path
        fill="url(#SVGIDD_20_)"
        d="M361.867,452l-98.133,35.732V484.8l97.867-43.467C361.333,446.666,361.6,449.866,361.867,452z"
      />
      <linearGradient
        id="SVGIDD_21_"
        gradientUnits="userSpaceOnUse"
        x1="-1580.5547"
        y1="19.3181"
        x2="-1598.0365"
        y2="19.3181"
        gradientTransform="matrix(-1.197253e-010 2.6667 -2.6667 -1.197253e-010 364.3145 4377.0195)"
      >
        <stop offset="0.2" style="stop-color:#FFFFFF" />
        <stop offset="1" style="stop-color:#D8D8D8" />
      </linearGradient>
      <path
        fill="url(#SVGIDD_21_)"
        d="M361.867,151.467l-98.133-36v2.933l97.867,43.467C361.333,156.8,361.6,153.6,361.867,151.467z"
      />
      <g>
        <path
          fill="#7F8080"
          d="M469.066,92.8l29.601,20.267c16.8,11.467,26.933,30.667,26.933,51.2v274.933
		c0,20.533-10.133,39.467-26.933,51.2l-29.334,20c-3.733,2.4-6.933,2.4-6.933,2.134c-1.867-0.267-3.2-1.601-3.733-2.934l0,0
		c-0.267-0.533-0.533-1.867-0.801-2.4c1.067-0.267,1.867-0.8,2.934-1.6l31.467-19.733c18.134-11.2,28.8-29.866,28.8-49.866V167.467
		c0-20-10.666-38.667-28.8-49.867l-31.733-19.733c-1.066-0.533-1.866-1.066-2.934-1.333C458.4,90.933,462.934,88.533,469.066,92.8z"
        />
      </g>
      <linearGradient
        id="SVGIDD_22_"
        gradientUnits="userSpaceOnUse"
        x1="605.1875"
        y1="-1.6658"
        x2="639.7112"
        y2="5.045"
        gradientTransform="matrix(1.197253e-010 -2.6667 -2.6667 -1.197253e-010 364.3145 2201.6411)"
      >
        <stop offset="0" style="stop-color:#666666" />
        <stop offset="0.4519" style="stop-color:#000000" />
      </linearGradient>
      <path
        fill="url(#SVGIDD_22_)"
        d="M398.933,486.4c2.401,1.333,3.467,5.066,2.401,10.934L390.667,552l0,0L387.2,570.4
	c-1.333,7.467-5.6,12.8-11.2,16c-1.6,0-3.2,0-4.8,0c-20.267-0.8-40-6.399-57.6-16.533c5.333-0.267,9.6-2.667,15.2-8.267
	c0.267,0.533,0.534,0.8,0.8,1.333c1.333,1.867,2.933,3.467,4.8,4.267c1.333,0.533,2.667,1.067,4,1.067l18.4,1.066
	c14.667,0.8,27.733-9.601,30.667-24L398.933,486.4z"
      />
      <linearGradient
        id="SVGIDD_23_"
        gradientUnits="userSpaceOnUse"
        x1="779.4336"
        y1="-1.2351"
        x2="818.2647"
        y2="6.3129"
        gradientTransform="matrix(1.197253e-010 -2.6667 -2.6667 -1.197253e-010 364.3145 2201.6411)"
      >
        <stop offset="0.5481" style="stop-color:#000000" />
        <stop offset="1" style="stop-color:#666666" />
      </linearGradient>
      <path
        fill="url(#SVGIDD_23_)"
        d="M377.333,16.533c4.8,4,8.533,9.866,9.867,16.533l3.733,18.4l10.666,54.399
	c1.066,5.867,0.268,9.601-2.399,10.934l-11.467-58.934c-1.067-6.133-4.267-11.467-8.533-15.467c-5.867-5.6-13.867-8.8-22.133-8.533
	l-18.4,1.066c-1.333,0-2.667,0.268-4,0.801c-2.133,0.8-4,2.399-5.066,4.533c-0.267,0.533-0.534,0.8-0.8,1.333
	c-5.867-5.866-10.4-8-16-8.267c0,0,0,0,0.267,0c17.6-10.4,37.866-16.267,58.4-16.8C373.067,16.533,374.933,16.533,377.333,16.533z"
      />
      <g id="Bar_2_">
        <radialGradient
          id="SVGIDD_24_"
          cx="712.4648"
          cy="-46.8821"
          r="55.1284"
          gradientTransform="matrix(1.197253e-010 -2.6667 -2.6667 -1.197253e-010 364.3145 2201.6411)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" style="stop-color:#1A1A1A" />
          <stop offset="1" style="stop-color:#000000" />
        </radialGradient>
        <path
          fill="url(#SVGIDD_24_)"
          v-on:click="changeSeverity('bumper')"
          d="M457.6,96.267c0.801,0.267,1.867,0.8,2.934,1.333l31.733,19.733
		c18.134,11.2,28.8,29.867,28.8,49.867V436c0,20-10.666,38.666-28.8,49.866L460.8,505.6c-1.066,0.533-2.133,1.066-2.934,1.6
		c-0.267-1.066-0.267-2.133,0-3.199c2.134-38.934,3.733-74.134,4.801-107.467h5.066c2.667,0,4.8-1.867,4.8-4.533V215.2
		c0-2.4-2.133-4.534-4.8-4.534h-5.066C461.6,176.267,460,139.734,457.866,99.2C457.6,98.4,457.6,97.333,457.6,96.267z"
        />

        <linearGradient
          id="SVGIDD_25_"
          gradientUnits="userSpaceOnUse"
          x1="670.6738"
          y1="-47.844"
          x2="671.8612"
          y2="-47.218"
          gradientTransform="matrix(1.197253e-010 -2.6667 -2.6667 -1.197253e-010 364.3145 2201.6411)"
        >
          <stop offset="0" style="stop-color:#0C0C0C" />
          <stop offset="0.4895" style="stop-color:#262626" />
          <stop offset="1" style="stop-color:#0C0C0C" />
        </linearGradient>
        <polygon
          fill="url(#SVGIDD_25_)"
          points="521.066,397.866 461.066,429.067 461.333,425.333 521.066,394.133 	"
        />

        <linearGradient
          id="SVGIDD_26_"
          gradientUnits="userSpaceOnUse"
          x1="-1345.1421"
          y1="-47.8459"
          x2="-1343.9547"
          y2="-47.22"
          gradientTransform="matrix(-1.197253e-010 2.6667 -2.6667 -1.197253e-010 364.3145 3777.3264)"
        >
          <stop offset="0" style="stop-color:#0C0C0C" />
          <stop offset="0.4895" style="stop-color:#262626" />
          <stop offset="1" style="stop-color:#0C0C0C" />
        </linearGradient>
        <polygon
          fill="url(#SVGIDD_26_)"
          points="521.066,205.6 461.066,174.4 461.333,178.133 521.066,209.333 	"
        />

        <linearGradient
          id="SVGIDD_27_"
          gradientUnits="userSpaceOnUse"
          x1="712.4648"
          y1="-55.0676"
          x2="712.4648"
          y2="-53.2051"
          gradientTransform="matrix(1.197253e-010 -2.6667 -2.6667 -1.197253e-010 364.3145 2201.6411)"
        >
          <stop offset="0" style="stop-color:#0C0C0C" />
          <stop offset="0.4895" style="stop-color:#262626" />
          <stop offset="1" style="stop-color:#0C0C0C" />
        </linearGradient>
        <path
          fill="url(#SVGIDD_27_)"
          d="M511.2,301.6c0,35.733-0.267,69.333-0.8,94.133C509.333,440,508.267,440,506.134,440V163.467
		c2.133,0,3.199,0,4,44.267C510.934,232.533,511.2,265.866,511.2,301.6z"
        />

        <linearGradient
          id="SVGIDD_28_"
          v-on:click="changeSeverity('bumper')"
          gradientUnits="userSpaceOnUse"
          x1="712.4648"
          y1="-50.3616"
          x2="712.4648"
          y2="-48.499"
          gradientTransform="matrix(1.197253e-010 -2.6667 -2.6667 -1.197253e-010 364.3145 2201.6411)"
        >
          <stop offset="0" style="stop-color:#0C0C0C" />
          <stop offset="0.4895" style="stop-color:#262626" />
          <stop offset="1" style="stop-color:#0C0C0C" />
        </linearGradient>
        <path
          fill="url(#SVGIDD_28_)"
          d="M498.667,301.6c0,35.733-0.267,69.333-0.801,94.133C496.8,440,495.733,440,493.6,440V163.467
		c2.134,0,3.2,0,4,44.267C498.4,232.533,498.667,265.866,498.667,301.6z"
        />

        <linearGradient
          id="SVGIDD_29_"
          gradientUnits="userSpaceOnUse"
          x1="712.4648"
          y1="-45.6555"
          x2="712.4648"
          y2="-43.7932"
          gradientTransform="matrix(1.197253e-010 -2.6667 -2.6667 -1.197253e-010 364.3145 2201.6411)"
        >
          <stop offset="0" style="stop-color:#0C0C0C" />
          <stop offset="0.4895" style="stop-color:#262626" />
          <stop offset="1" style="stop-color:#0C0C0C" />
        </linearGradient>
        <path
          fill="url(#SVGIDD_29_)"
          d="M486.134,301.6c0,35.733-0.267,69.333-0.801,94.133C484.267,440,483.2,440,481.066,440V163.467
		c2.134,0,3.2,0,4,44.267C485.866,232.533,486.134,265.866,486.134,301.6z"
        />
      </g>
      <g id="Radiator_3_">
        <radialGradient
          id="SVGIDD_30_"
          cx="712.4141"
          cy="-11.1326"
          r="41.8411"
          gradientTransform="matrix(1.197253e-010 -2.6667 -2.6667 -1.197253e-010 364.3145 2201.6411)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" style="stop-color:#333333" />
          <stop offset="1" style="stop-color:#000000" />
        </radialGradient>
        <path
          fill="url(#SVGIDD_30_)"
          d="M365.333,156v291.732c0,9.867,5.867,12.268,13.333,5.334l32.534-31.2
		c7.2-6.934,11.467-16.533,11.467-26.4V208.8c0-9.867-4.001-19.467-11.467-26.4l-32.534-31.733
		C371.467,143.734,365.333,146.133,365.333,156z"
        />
        <g>
          <linearGradient
            id="SVGIDD_31_"
            gradientUnits="userSpaceOnUse"
            x1="712.3691"
            y1="-5.0793"
            x2="712.3691"
            y2="-3.1017"
            gradientTransform="matrix(1.197253e-010 -2.6667 -2.6667 -1.197253e-010 364.3145 2201.6411)"
          >
            <stop offset="0" style="stop-color:#1A1A1A" />
            <stop offset="0.3556" style="stop-color:#FFFFFF" />
            <stop offset="0.6778" style="stop-color:#FFFFFF" />
            <stop offset="1" style="stop-color:#7F8080" />
          </linearGradient>
          <path
            fill="url(#SVGIDD_31_)"
            d="M377.867,453.866v-304c-1.6,0.267-5.067-0.267-5.333,0v304.267
			C372.8,454.4,376.267,453.6,377.867,453.866z"
          />

          <linearGradient
            id="SVGIDD_32_"
            gradientUnits="userSpaceOnUse"
            x1="769.4434"
            y1="-4.0818"
            x2="655.2939"
            y2="-4.0818"
            gradientTransform="matrix(1.197253e-010 -2.6667 -2.6667 -1.197253e-010 364.3145 2201.6411)"
          >
            <stop offset="0" style="stop-color:#333333" />
            <stop offset="0.2" style="stop-color:#CBCACA" />
            <stop offset="0.8" style="stop-color:#CBCACA" />
            <stop offset="1" style="stop-color:#333333" />
          </linearGradient>
          <path
            fill="url(#SVGIDD_32_)"
            d="M377.867,453.866v-304c-1.6,0.267-5.067-0.267-5.333,0v304.267
			C372.8,454.4,376.267,453.6,377.867,453.866z"
          />
        </g>
        <g>
          <linearGradient
            id="SVGIDD_33_"
            gradientUnits="userSpaceOnUse"
            x1="712.3652"
            y1="-8.6091"
            x2="712.3652"
            y2="-6.6312"
            gradientTransform="matrix(1.197253e-010 -2.6667 -2.6667 -1.197253e-010 364.3145 2201.6411)"
          >
            <stop offset="0" style="stop-color:#1A1A1A" />
            <stop offset="0.3556" style="stop-color:#FFFFFF" />
            <stop offset="0.6778" style="stop-color:#FFFFFF" />
            <stop offset="1" style="stop-color:#7F8080" />
          </linearGradient>
          <path
            fill="url(#SVGIDD_33_)"
            d="M387.2,448V156c-1.6,0.267-5.067-0.267-5.333,0v292C382.133,448.267,385.6,447.733,387.2,448z"
          />

          <linearGradient
            id="SVGIDD_34_"
            gradientUnits="userSpaceOnUse"
            x1="767.1426"
            y1="-7.5823"
            x2="657.5859"
            y2="-7.5823"
            gradientTransform="matrix(1.197253e-010 -2.6667 -2.6667 -1.197253e-010 364.3145 2201.6411)"
          >
            <stop offset="0" style="stop-color:#333333" />
            <stop offset="0.2" style="stop-color:#CBCACA" />
            <stop offset="0.8" style="stop-color:#CBCACA" />
            <stop offset="1" style="stop-color:#333333" />
          </linearGradient>
          <path
            fill="url(#SVGIDD_34_)"
            d="M387.2,448V156c-1.6,0.267-5.067-0.267-5.333,0v292C382.133,448.267,385.6,447.733,387.2,448z"
          />
        </g>
        <g>
          <linearGradient
            id="SVGIDD_35_"
            gradientUnits="userSpaceOnUse"
            x1="712.3789"
            y1="-12.1384"
            x2="712.3789"
            y2="-10.1608"
            gradientTransform="matrix(1.197253e-010 -2.6667 -2.6667 -1.197253e-010 364.3145 2201.6411)"
          >
            <stop offset="0" style="stop-color:#1A1A1A" />
            <stop offset="0.3556" style="stop-color:#FFFFFF" />
            <stop offset="0.6778" style="stop-color:#FFFFFF" />
            <stop offset="1" style="stop-color:#7F8080" />
          </linearGradient>
          <path
            fill="url(#SVGIDD_35_)"
            d="M396.8,438.4V165.333c-1.6,0.267-5.066-0.267-5.333,0v273.333
			C391.733,438.666,394.933,438.133,396.8,438.4z"
          />

          <linearGradient
            id="SVGIDD_36_"
            gradientUnits="userSpaceOnUse"
            x1="763.6426"
            y1="-11.1819"
            x2="661.1143"
            y2="-11.1819"
            gradientTransform="matrix(1.197253e-010 -2.6667 -2.6667 -1.197253e-010 364.3145 2201.6411)"
          >
            <stop offset="0" style="stop-color:#333333" />
            <stop offset="0.2" style="stop-color:#CBCACA" />
            <stop offset="0.8" style="stop-color:#CBCACA" />
            <stop offset="1" style="stop-color:#333333" />
          </linearGradient>
          <path
            fill="url(#SVGIDD_36_)"
            d="M396.8,438.4V165.333c-1.6,0.267-5.066-0.267-5.333,0v273.333
			C391.733,438.666,394.933,438.133,396.8,438.4z"
          />
        </g>
        <g>
          <linearGradient
            id="SVGIDD_37_"
            gradientUnits="userSpaceOnUse"
            x1="712.2793"
            y1="-15.6677"
            x2="712.2793"
            y2="-13.6904"
            gradientTransform="matrix(1.197253e-010 -2.6667 -2.6667 -1.197253e-010 364.3145 2201.6411)"
          >
            <stop offset="0" style="stop-color:#1A1A1A" />
            <stop offset="0.3556" style="stop-color:#FFFFFF" />
            <stop offset="0.6778" style="stop-color:#FFFFFF" />
            <stop offset="1" style="stop-color:#7F8080" />
          </linearGradient>
          <path
            fill="url(#SVGIDD_37_)"
            d="M406.133,429.6V174.933c-1.6,0.268-5.066-0.267-5.333,0V429.6
			C401.066,429.6,404.533,429.333,406.133,429.6z"
          />

          <linearGradient
            id="SVGIDD_38_"
            gradientUnits="userSpaceOnUse"
            x1="760.043"
            y1="-14.6819"
            x2="664.5146"
            y2="-14.6819"
            gradientTransform="matrix(1.197253e-010 -2.6667 -2.6667 -1.197253e-010 364.3145 2201.6411)"
          >
            <stop offset="0" style="stop-color:#333333" />
            <stop offset="0.2" style="stop-color:#CBCACA" />
            <stop offset="0.8" style="stop-color:#CBCACA" />
            <stop offset="1" style="stop-color:#333333" />
          </linearGradient>
          <path
            fill="url(#SVGIDD_38_)"
            d="M406.133,429.6V174.933c-1.6,0.268-5.066-0.267-5.333,0V429.6
			C401.066,429.6,404.533,429.333,406.133,429.6z"
          />
        </g>
        <g>
          <linearGradient
            id="SVGIDD_39_"
            gradientUnits="userSpaceOnUse"
            x1="712.3066"
            y1="-19.1975"
            x2="712.3066"
            y2="-17.2191"
            gradientTransform="matrix(1.197253e-010 -2.6667 -2.6667 -1.197253e-010 364.3145 2201.6411)"
          >
            <stop offset="0" style="stop-color:#1A1A1A" />
            <stop offset="0.3556" style="stop-color:#FFFFFF" />
            <stop offset="0.6778" style="stop-color:#FFFFFF" />
            <stop offset="1" style="stop-color:#7F8080" />
          </linearGradient>
          <path
            fill="url(#SVGIDD_39_)"
            d="M415.467,421.333v-238.4c-1.6,0.268-5.066-0.267-5.334,0v238.4
			C410.4,421.6,413.867,421.333,415.467,421.333z"
          />

          <linearGradient
            id="SVGIDD_40_"
            gradientUnits="userSpaceOnUse"
            x1="757.043"
            y1="-18.1819"
            x2="667.5703"
            y2="-18.1819"
            gradientTransform="matrix(1.197253e-010 -2.6667 -2.6667 -1.197253e-010 364.3145 2201.6411)"
          >
            <stop offset="0" style="stop-color:#333333" />
            <stop offset="0.2" style="stop-color:#CBCACA" />
            <stop offset="0.8" style="stop-color:#CBCACA" />
            <stop offset="1" style="stop-color:#333333" />
          </linearGradient>
          <path
            fill="url(#SVGIDD_40_)"
            d="M415.467,421.333v-238.4c-1.6,0.268-5.066-0.267-5.334,0v238.4
			C410.4,421.6,413.867,421.333,415.467,421.333z"
          />
        </g>
        <g>
          <image
            v-on:click="changeSeverity('bonnet')"
            overflow="visible"
            enable-background="new    "
            width="25"
            height="120"
            xlink:href="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABkAAAB4CAYAAAAHQVmcAAAACXBIWXMAAAsSAAALEgHS3X78AAAA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"
            transform="matrix(2.6667 0 0 2.6667 360.0005 141.3333)"
          ></image>
        </g>
        <g id="Logo_4_">
          <linearGradient
            id="SVGIDD_41_"
            gradientUnits="userSpaceOnUse"
            x1="711.8145"
            y1="-13.6174"
            x2="711.8145"
            y2="-4.9387"
            gradientTransform="matrix(1.197253e-010 -2.6667 -2.6667 -1.197253e-010 364.3145 2201.6411)"
          >
            <stop offset="0" style="stop-color:#333333" />
            <stop offset="1" style="stop-color:#FFFFFF" />
          </linearGradient>
          <circle
            fill="url(#SVGIDD_41_)"
            cx="389.067"
            cy="303.467"
            r="11.466"
          />

          <linearGradient
            id="SVGIDD_42_"
            gradientUnits="userSpaceOnUse"
            x1="-165.3794"
            y1="895.4563"
            x2="-165.3794"
            y2="902.767"
            gradientTransform="matrix(-1.197253e-010 2.6667 2.6667 1.197253e-010 -2008.5742 744.4749)"
          >
            <stop offset="0" style="stop-color:#808080" />
            <stop offset="1" style="stop-color:#FFFFFF" />
          </linearGradient>
          <circle fill="url(#SVGIDD_42_)" cx="389.067" cy="303.467" r="9.867" />
        </g>
      </g>
      <g id="Lamp_4_">
        <linearGradient
          id="SVGIDD_43_"
          gradientUnits="userSpaceOnUse"
          x1="624.458"
          y1="-49.7244"
          x2="635.9159"
          y2="-45.7791"
          gradientTransform="matrix(1.197253e-010 -2.6667 -2.6667 -1.197253e-010 364.3145 2201.6411)"
        >
          <stop offset="0" style="stop-color:#4E4D4D" />
          <stop offset="1" style="stop-color:#0C0C0C" />
        </linearGradient>
        <path
          fill="url(#SVGIDD_43_)"
          v-on:click="changeSeverity('bumper')"
          d="M502.934,508.533L484.8,520.8c-4,2.666-7.467,5.6-10.666,9.066l11.466,10.4l21.867-32.801
		C506.134,507.199,504.533,507.733,502.934,508.533z"
        />

        <linearGradient
          id="SVGIDD_44_"
          gradientUnits="userSpaceOnUse"
          x1="619.4824"
          y1="-34.0334"
          x2="619.8887"
          y2="-45.669"
          gradientTransform="matrix(1.197253e-010 -2.6667 -2.6667 -1.197253e-010 364.3145 2201.6411)"
        >
          <stop offset="0" style="stop-color:#0C0C0C" />
          <stop offset="1" style="stop-color:#4E4D4D" />
        </linearGradient>
        <path
          fill="url(#SVGIDD_44_)"
          v-on:click="changeSeverity('bumper')"
          d="M464.8,568.267l2.667-0.534l18.4-27.466l-11.467-10.4c-9.334,9.866-15.467,22.4-17.334,36v0.267
		C458.4,568.267,461.333,569.067,464.8,568.267z"
        />

        <linearGradient
          id="SVGIDD_45_"
          gradientUnits="userSpaceOnUse"
          x1="610.7002"
          y1="-46.8181"
          x2="622.1056"
          y2="-42.8909"
          gradientTransform="matrix(1.197253e-010 -2.6667 -2.6667 -1.197253e-010 364.3145 2201.6411)"
        >
          <stop offset="0" style="stop-color:#0C0C0C" />
          <stop offset="1" style="stop-color:#4E4D4D" />
        </linearGradient>
        <path
          fill="url(#SVGIDD_45_)"
          v-on:click="changeSeverity('bumper')"
          d="M488.533,562.666c5.333-1.333,10.4-3.733,14.4-7.2l-17.067-15.199l-18.399,27.466L488.533,562.666z
		"
        />

        <linearGradient
          id="SVGIDD_46_"
          gradientUnits="userSpaceOnUse"
          x1="626.1973"
          y1="-56.2488"
          x2="626.5662"
          y2="-45.6833"
          gradientTransform="matrix(1.197253e-010 -2.6667 -2.6667 -1.197253e-010 364.3145 2201.6411)"
        >
          <stop offset="0" style="stop-color:#0C0C0C" />
          <stop offset="1" style="stop-color:#4E4D4D" />
        </linearGradient>
        <path
          fill="url(#SVGIDD_46_)"
          v-on:click="changeSeverity('bumper')"
          d="M507.733,507.466l-21.866,32.801l17.066,15.199c3.2-2.666,6.133-5.6,8.267-9.333l3.733-29.6v-2.4
		C514.4,510.666,511.467,507.733,507.733,507.466z"
        />

        <radialGradient
          id="SVGIDD_47_"
          cx="-151.6611"
          cy="-45.946"
          r="3.4872"
          gradientTransform="matrix(-1.197253e-010 2.6667 -2.6667 -1.197253e-010 364.3145 948.428)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.1297" style="stop-color:#B3B3B2" />
          <stop offset="0.9623" style="stop-color:#0D0D0D" />
        </radialGradient>
        <circle
          fill="url(#SVGIDD_47_)"
          v-on:click="changeSeverity('bumper')"
          cx="486.934"
          cy="544"
          r="9.333"
        />
      </g>
      <g id="Lamp_1_">
        <linearGradient
          id="SVGIDD_48_"
          gradientUnits="userSpaceOnUse"
          x1="-1616.2905"
          y1="-49.7078"
          x2="-1604.8328"
          y2="-45.7627"
          gradientTransform="matrix(-1.197253e-010 2.6667 -2.6667 -1.197253e-010 364.3145 4377.0195)"
        >
          <stop offset="0" style="stop-color:#4E4D4D" />
          <stop offset="1" style="stop-color:#0C0C0C" />
        </linearGradient>
        <path
          fill="url(#SVGIDD_48_)"
          d="M502.934,94.666L484.8,82.4c-4-2.666-7.467-5.6-10.666-9.066l11.466-10.4l21.867,32.801
		C506.134,96,504.533,95.734,502.934,94.666z"
        />

        <linearGradient
          id="SVGIDD_49_"
          gradientUnits="userSpaceOnUse"
          x1="-1621.314"
          y1="-34.0359"
          x2="-1620.9076"
          y2="-45.6714"
          gradientTransform="matrix(-1.197253e-010 2.6667 -2.6667 -1.197253e-010 364.3145 4377.0195)"
        >
          <stop offset="0" style="stop-color:#0C0C0C" />
          <stop offset="1" style="stop-color:#4E4D4D" />
        </linearGradient>
        <path
          fill="url(#SVGIDD_49_)"
          v-on:click="changeSeverity('bumper')"
          d="M464.8,34.933l2.667,0.534l18.4,27.466l-11.467,10.4c-9.334-9.866-15.467-22.4-17.334-36v-0.267
		C458.4,34.933,461.333,34.133,464.8,34.933z"
        />

        <linearGradient
          id="SVGIDD_50_"
          gradientUnits="userSpaceOnUse"
          x1="-1630.0376"
          y1="-46.8313"
          x2="-1618.6322"
          y2="-42.9041"
          gradientTransform="matrix(-1.197253e-010 2.6667 -2.6667 -1.197253e-010 364.3145 4377.0195)"
        >
          <stop offset="0" style="stop-color:#0C0C0C" />
          <stop offset="1" style="stop-color:#4E4D4D" />
        </linearGradient>
        <path
          fill="url(#SVGIDD_50_)"
          v-on:click="changeSeverity('bumper')"
          d="M488.533,40.8c5.333,1.333,10.4,3.733,14.4,7.2l-17.067,15.2l-18.399-27.467L488.533,40.8z"
        />

        <linearGradient
          id="SVGIDD_51_"
          gradientUnits="userSpaceOnUse"
          x1="-1614.5"
          y1="-56.2512"
          x2="-1614.1307"
          y2="-45.6747"
          gradientTransform="matrix(-1.197253e-010 2.6667 -2.6667 -1.197253e-010 364.3145 4377.0195)"
        >
          <stop offset="0" style="stop-color:#0C0C0C" />
          <stop offset="1" style="stop-color:#4E4D4D" />
        </linearGradient>
        <path
          fill="url(#SVGIDD_51_)"
          v-on:click="changeSeverity('bumper')"
          d="M507.733,96l-21.866-32.8L502.934,48c3.2,2.666,6.133,5.6,8.267,9.333l3.733,29.6v2.4
		C514.4,92.8,511.467,95.734,507.733,96z"
        />

        <radialGradient
          id="SVGIDD_52_"
          cx="2089.0859"
          cy="-45.9465"
          r="3.4848"
          gradientTransform="matrix(1.197253e-010 -2.6667 -2.6667 -1.197253e-010 364.3145 5630.2324)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.1297" style="stop-color:#B3B3B2" />
          <stop offset="0.9623" style="stop-color:#0D0D0D" />
        </radialGradient>
        <circle
          fill="url(#SVGIDD_52_)"
          v-on:click="changeSeverity('bumper')"
          cx="486.934"
          cy="59.467"
          r="9.333"
        />
      </g>
      <g id="Lines_1_">
        <g>
          <polygon
            points="362.933,455.199 362.933,488.267 361.867,488.8 361.867,452 		"
          />
        </g>
        <path
          d="M328.267,560.8l0.267,0.8c-5.867,5.866-9.6,8-15.2,8.267L312.8,569.6C318.4,569.333,322.667,566.133,328.267,560.8z"
        />
        <g>
          <polygon
            points="362.933,148.267 362.933,115.2 361.867,114.666 361.867,151.467 		"
          />
        </g>
        <path
          d="M328.267,42.666l0.267-0.8c-5.867-5.866-10.4-8-16.267-8.267L312,33.866C317.6,34.133,322.667,37.067,328.267,42.666z"
        />
        <path
          d="M402.4,467.733c0,1.334-0.268,2.934-0.533,4.534l-14.4,73.066c-2.934,14.399-16,24.8-30.667,24l-18.4-1.066
		c-3.733-0.268-6.933-2.134-9.066-5.334c-1.867-3.2-2.133-6.934-0.8-10.399l15.2-34.4c8-18.133,20.533-34.4,36.267-46.934
		l8.533-6.933c4.534-3.733,8.534-4.801,10.934-3.2C401.334,462.133,402.4,464.267,402.4,467.733z M338.4,567.199l18.4,1.067
		c14.134,0.8,26.934-9.334,29.6-23.2L400.8,472c1.067-5.334,0.267-9.067-1.866-10.134c-2.134-1.333-5.867-0.267-9.867,3.2
		L380.533,472c-15.466,12.267-28,28.267-35.733,46.399l-15.2,34.4c-1.333,3.199-1.067,6.666,0.8,9.6
		C332,565.333,334.933,567.199,338.4,567.199L338.4,567.199z"
        />
        <path
          d="M399.733,142.4c-2.667,1.601-6.4,0.533-10.934-3.199l-8.533-6.934c-16-12.267-28.533-28.533-36.533-46.934l-15.2-34.4
		c-1.6-3.466-1.333-7.199,0.8-10.399c1.867-3.2,5.333-5.066,9.066-5.333l18.4-1.067c14.667-0.8,27.733,9.601,30.667,24l14.4,73.067
		c0.266,1.6,0.533,3.199,0.533,4.533C402.4,138.933,401.334,141.333,399.733,142.4z M338.4,36c-3.466,0.267-6.4,1.866-8.267,4.8
		s-2.133,6.4-0.8,9.6l15.2,34.4c8,18.133,20.267,34.133,35.733,46.4l8.533,6.933c4.267,3.2,7.733,4.533,9.867,3.2
		s2.667-5.066,1.867-10.133l-14.4-73.067c-2.667-13.866-15.467-23.733-29.6-23.2L338.4,36L338.4,36z"
        />
        <path
          opacity="0.5"
          enable-background="new    "
          d="M445.066,441.333L445.066,441.333l-1.333,14.133
		c-0.267,1.601-1.6,2.934-2.934,3.467l-9.6,2.4c-0.8,0.267-1.601,0-2.134-0.267c-0.533-0.533-0.8-1.066-0.533-1.867l1.334-13.866
		c0.267-1.601,1.6-2.934,2.933-3.467l9.601-2.4c0.8-0.267,1.6,0,2.133,0.267C444.8,440,445.066,440.533,445.066,441.333z
		 M444.533,441.333c0-0.533,0-1.066-0.533-1.333c-0.267-0.268-1.066-0.534-1.6-0.268l-9.601,2.4c-1.333,0.267-2.666,1.6-2.666,2.934
		l-1.334,13.866c0,0.533,0,1.066,0.533,1.334c0.267,0.267,1.067,0.533,1.601,0.267l9.6-2.4c1.333-0.267,2.667-1.6,2.667-2.934
		L444.533,441.333z"
        />
        <path
          opacity="0.5"
          enable-background="new    "
          d="M444.533,163.467C444,164,443.2,164,442.4,163.734l-9.601-2.4
		c-1.6-0.267-2.934-1.866-2.934-3.467L428.533,144c0-0.8,0.267-1.334,0.533-1.867c0.533-0.533,1.334-0.533,2.134-0.267l9.6,2.4
		c1.601,0.267,2.934,1.866,2.934,3.467l1.333,13.866v0.267C445.066,162.666,444.8,163.2,444.533,163.467z M443.2,148
		c0-1.334-1.334-2.667-2.667-2.934l-9.6-2.4c-0.533-0.267-1.334,0-1.601,0.267c-0.267,0.268-0.533,0.801-0.533,1.334l1.334,13.866
		c0,1.334,1.333,2.667,2.666,2.934l9.601,2.4c0.533,0.267,1.333,0,1.6-0.267c0.267-0.268,0.533-0.801,0.533-1.334L443.2,148z"
        />
      </g>
      <path fill="#F1F1F1" d="M312.267,33.6" />
    </svg>
  </div>
</template>
<script>
export default {
  props: {
    bumper: Number,
    bonnet: Number
  },

  data() {
    return {
      front: {
        bumper: 0,
        bonnet: 0
      }
    };
  },

  computed: {
    bumperClass() {
      return this.getSeverityColour(this.front.bumper, {
        fill: 'url(#SVGIDD_1_)'
      });
    },

    bonnetClass() {
      return this.getSeverityColour(this.front.bonnet);
    }
  },

  methods: {
    changeSeverity(section) {
      if (this.front[section] == 3) {
        this.front[section] = 0;
      } else {
        this.front[section] = this.front[section] + 1;
      }

      this.$emit('updated', this.front);
    },

    getSeverityColour(severity, defaultColour = '#D9D9D9', opacity = null) {
      const colour = this.getColour(severity, defaultColour);

      if (opacity) {
        return {
          opacity,
          ...colour
        };
      }

      return colour;
    },

    getColour(severity, defaultColour = '#D9D9D9') {
      switch (severity) {
        case 1:
          return {
            fill: '#FFCA28'
          };

        case 2:
          return {
            fill: '#f0ad4e'
          };

        case 3:
          return {
            fill: '#d9534f'
          };

        default:
          return typeof defaultColour === 'string'
            ? {
                fill: defaultColour
              }
            : defaultColour;
      }
    }
  },

  watch: {
    bumper(value) {
      this.front.bumper = value;
    },

    bonnet(value) {
      this.front.bonnet = value;
    }
  }
};
</script>
